import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容导航",
    links: [
      { to: "/", label: "首页" },
      { to: "/topics", label: "爆料追踪" },
      { to: "/method", label: "真假辨析" },
    ],
  },
  {
    title: "了解我们",
    links: [
      { to: "/about", label: "关于我们" },
      { to: "/faq", label: "常见问题" },
      { to: "/about", label: "内容原则" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-20 border-t border-background-300 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-radar-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">蝌蚪爆料</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              把零散的传闻整理成可追溯的时间线与证据清单，标注每一项依据的强度与来源，
              帮助你在争议信息里先看到依据，再形成判断。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 font-label text-xs text-foreground-500">
              <i className="ri-mail-line" /> 投稿与更正：contact@kodo-expose.example.com
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-label text-xs font-semibold uppercase tracking-wide text-foreground-500">
                {col.title}
              </h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="font-label text-sm text-foreground-700 transition-colors hover:text-primary-700 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-foreground-500">
            © 2026 蝌蚪爆料 · 内容仅呈现公开可查依据，不构成对任何一方的定性结论
          </p>
          <p className="font-label text-xs text-foreground-500">
            依据分级 · 交叉验证 · 溯源标注
          </p>
        </div>
      </div>
    </footer>
  );
}